export enum TypeContratUtilisateur {
  CDI = "CDI",
  CDD = "CDD",
  INTERIM = "Interim",
  STAGE = "Stage"
}